import React from 'react'
import clsx from 'clsx'

import type { IStaff } from 'features/Staff'
import type { IColumn } from 'types'
import type { IIndexable } from 'helpers/model'
import { STATUS_OPTIONS, ROLE_OPTIONS } from 'helpers/constants/common'

interface IStaffSingle {
  data: IStaff & IIndexable
  onRowClick: (id: string) => void
  columns: IColumn[]
}

interface IStaffSingleTable extends IStaff {
  name: string
}

const StaffSingle: React.FC<IStaffSingle> = ({
  data,
  onRowClick = () => {},
  columns,
}: IStaffSingle) => {
  const base = 'f-staff-list'

  const nickName = data && data.nickName ? `(${data.nickName})` : ''
  const fullName = `${data.firstName} ${data.lastName}`
  const role =
    ROLE_OPTIONS.find(({ key }) => key === data?.role)?.label || data?.role
  const status =
    STATUS_OPTIONS.find(({ key }) => key === data?.status)?.label ||
    STATUS_OPTIONS[0].label

  const dataTable: IStaffSingleTable & IIndexable = {
    ...data,
    name: `${nickName} ${fullName}`,
    role,
    status,
  }

  return (
    <tr className={`${base}__list-row`} onClick={() => onRowClick(data.id)}>
      {columns.map((column, indexInner) => (
        <td className={`${base}__cell--w${column.width}`} key={indexInner}>
          <div className={`${base}__cell-body-wrapper`}>
            <span
              className={clsx(
                column.key === 'area' && `${base}__area`,
                `${base}__cell-body-text`,
              )}
            >
              {dataTable[column.key] || '-'}
            </span>
          </div>
        </td>
      ))}
    </tr>
  )
}

export default StaffSingle
